import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import Swal from "sweetalert2";
import "./index.css";

const CadUploadEstrutura = () => {
  const navigate = useNavigate();
  const { IDProcesso, IDDiretorioPai, NomeBucketAws } = useParams();
  const [clienteLogado, setclienteLogado] = useState();
  const { objClienteAberto } = usePentagovContext();
  const { IDOperador, nome, operador } = useOperador();
  const { authReady } = useAuthContext();

  const [arquivos, setArquivos] = useState([]);
  const [pastasCriadas, setPastasCriadas] = useState(new Map());
  const [progresso, setProgresso] = useState(0);
  const [total, setTotal] = useState(0);
  const [concluidos, setConcluidos] = useState(0);
  const [falhas, setFalhas] = useState(0);
  const [logErros, setLogErros] = useState([]);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (operador && authReady) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setclienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  async function inicializaTela() {
    
  }

  // Escolher pasta inteira
  const handleSelecionarPasta = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    setArquivos(files);
    setTotal(files.length);
    setConcluidos(0);
    setFalhas(0);
    setProgresso(0);
    setLogErros([]);
  };

  const baixarLog = () => {
    const blob = new Blob([JSON.stringify(logErros, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "log_erros_migracao.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  const criarPastasSeNecessario = async (path, mapaPastas) => {
    const partes = path.split("/").filter(Boolean);
    let idPai = IDDiretorioPai;
    let chaveAcumulada = idPai ? `root-${idPai}` : "root";

    for (let i = 0; i < partes.length; i++) {
      const nome = partes[i];
      chaveAcumulada += `/${nome}`;

      if (mapaPastas.has(chaveAcumulada)) {
        idPai = mapaPastas.get(chaveAcumulada);
        continue;
      }

      try {
        const res = await api.post("/diretorio", {
          IDProcesso,
          IDCriador: IDOperador,
          descricao: nome,
          descricaoExibicao: nome,
          IDPai: idPai,
          IDFilho: null,
          nomeBucketAws: NomeBucketAws,
          tipo: "1",
          situacao: 1,
        });

        const novoId = res.data?.IDDiretorio;
        mapaPastas.set(chaveAcumulada, novoId);
        idPai = novoId;
      } catch (err) {
        console.error("Erro ao criar pasta:", nome, err);
        setFalhas((f) => f + 1);
        setLogErros((log) => [...log, { tipo: "pasta", nome, erro: err.message }]);
      }
    }

    return idPai;
  };


  // Iniciar upload de tudo
  const iniciarUpload = async () => {
    if (!IDProcesso?.trim()) {
      Swal.fire("Aviso", "ID do Processo não informado", "warning");
      return;
    }
    if (!arquivos.length) {
      Swal.fire("Aviso", "Selecione uma pasta antes de iniciar.", "warning");
      return;
    }

    setEnviando(true);

    const mapaPastas = new Map(); // mapa global que persiste durante todo o upload
    mapaPastas.set("root", IDDiretorioPai || null);

    for (let i = 0; i < arquivos.length; i++) {
      const file = arquivos[i];
      const relativePath = file.webkitRelativePath;
      const pastaPath = relativePath.substring(0, relativePath.lastIndexOf("/"));

      try {
        const idDiretorio = await criarPastasSeNecessario(pastaPath, mapaPastas);

        const formData = new FormData(); //aki aki aki
        formData.append("uploadId", crypto.randomUUID());
        formData.append("IDDiretorio", String(idDiretorio));
        formData.append("tipoPermissao", "99");
        formData.append("bucketName", NomeBucketAws);
        formData.append("arquivosInfo", JSON.stringify([{
          key: crypto.randomUUID(),
          originalName: file.name,
          size: file.size
        }]));
        formData.append("arquivos", file, file.name);
        formData.append("IDCriador", IDOperador);

        await api.post("/upload-direto", formData);

        setConcluidos((c) => c + 1);
      } catch (err) {
        console.error("Erro upload:", file.name, err);
        setFalhas((f) => f + 1);
        setLogErros((log) => [...log, { tipo: "arquivo", nome: file.name, erro: err.message }]);
      }

      setProgresso(Math.round(((i + 1) / total) * 100));
    }

    setEnviando(false);
    Swal.fire("Finalizado", "Processo concluído!", "success");
  };


  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={String(IDOperador).padStart(6, '0')} userName={nome} cliente={clienteLogado} />

        <div style={{ padding: 20 }}>
          <h3>Migrar Estruturas de Pasta para PentaGOV</h3>
          <br/><br/>

          <div style={{ marginBottom: 15 }}>
            <input
              type="file"
              {...{ webkitdirectory: "", directory: "", multiple: true }}
              onChange={handleSelecionarPasta}
            />

          </div>

          {arquivos.length > 0 && (
            <div style={{ marginBottom: 15 }}>
              <p>Total arquivos: {total}</p>
              <p>Concluídos: {concluidos}</p>
              <p>Falhas: {falhas}</p>
              <p>Restantes: {total - (concluidos + falhas)}</p>
              <div
                style={{
                  width: "100%",
                  background: "#ddd",
                  height: 20,
                  display: "flex",
                  justifyContent: "flex-start", // força o início à esquerda
                  borderRadius: 5,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${progresso}%`,
                    background: "#4caf50",
                    height: "100%",
                    transition: "width 300ms ease",
                  }}
                ></div>
              </div>
              <p style={{ textAlign: "left", marginTop: 5 }}>{progresso}%</p>
            </div>
          )}

          <button onClick={iniciarUpload} disabled={enviando}>
            {enviando ? "Enviando..." : "Iniciar Migração"}
          </button>
          <br/>
          
          {logErros.length > 0 && (  
            <button style={{ marginLeft: 10 }} onClick={baixarLog}>
              Baixar Log de Erros
            </button>
          )}
        </div>

      </div>
    </div>
  );
};

export default CadUploadEstrutura;
